export default __webpack_public_path__ + "static/media/avatar_4.9132f6d6.png";